import React from 'react';
import { Field, useFormikContext } from 'formik';

import { FormErrorUI, FormLabelUI, AutoCompleteSelectUI } from '../Interface';
import { getKanbanOrderList } from '../../config/config';
import { KanbanType } from '../../config/kanban';

const KanbanSettingFields = ({ viewField, submenuNames }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  return (
    <div className="grid grid-cols-6 gap-x-4 mx-4 mb-5">
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="defTaskKanbanOrder"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Feladat folyamat monitor sorrend" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defTaskKanbanOrder} />}
          onChange={(_e, newVal) => {
            setFieldValue('defTaskKanbanOrder', newVal?.value ?? null).then(() => {
              validateField('defTaskKanbanOrder');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defTaskKanbanOrder !== '' }}
          selectedValue={values.defTaskKanbanOrder}
          dataset={getKanbanOrderList(KanbanType.TASK)}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="defProjectKanbanOrder"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Projekt folyamat monitor sorrend" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defProjectKanbanOrder} />}
          onChange={(_e, newVal) => {
            setFieldValue('defProjectKanbanOrder', newVal?.value ?? null).then(() => {
              validateField('defProjectKanbanOrder');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defProjectKanbanOrder !== '' }}
          selectedValue={values.defProjectKanbanOrder}
          dataset={getKanbanOrderList(KanbanType.PROJECT)}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="defFeedbackKanbanOrder"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Feedback folyamat monitor sorrend" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defFeedbackKanbanOrder} />}
          onChange={(_e, newVal) => {
            setFieldValue('defFeedbackKanbanOrder', newVal?.value ?? null).then(() => {
              validateField('defFeedbackKanbanOrder');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defFeedbackKanbanOrder !== '' }}
          selectedValue={values.defFeedbackKanbanOrder}
          dataset={getKanbanOrderList(KanbanType.FEEDBACK)}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="defResourceKanbanOrder"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text={`${submenuNames[0] ?? 'Erőforrás 1'} folyamat monitor sorrend`} />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defResourceKanbanOrder} />}
          onChange={(_e, newVal) => {
            setFieldValue('defResourceKanbanOrder', newVal?.value ?? null).then(() => {
              validateField('defResourceKanbanOrder');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defResourceKanbanOrder !== '' }}
          selectedValue={values.defResourceKanbanOrder}
          dataset={getKanbanOrderList(KanbanType.RESOURCE)}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="defResourceThreeKanbanOrder"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text={`${submenuNames[1] ?? 'Erőforrás 3'} folyamat monitor sorrend`} />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defResourceThreeKanbanOrder} />}
          onChange={(_e, newVal) => {
            setFieldValue('defResourceThreeKanbanOrder', newVal?.value ?? null).then(() => {
              validateField('defResourceThreeKanbanOrder');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defResourceThreeKanbanOrder !== '' }}
          selectedValue={values.defResourceThreeKanbanOrder}
          dataset={getKanbanOrderList(KanbanType.RESOURCETHREE)}
        />
      </div>
    </div>
  );
};

export default KanbanSettingFields;
